export function groupBy<K, T>(key: keyof T, array: T[] = []): Record<K, T> {
  return array.reduce((map, item) => {
    map[item[key]] = item;
    return map;
  }, {} as Partial<Record<K, T>>);
}